import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  // 30s covers cold-start scenarios on slow mobile networks; the previous 15s
  // was too aggressive and caused an uncaught AxiosError overlay when a device
  // was hit by a transient network stall.
  timeout: 30000,
});

// Attach admin token (if any) for /admin routes.
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("lp_admin_token");
  if (adminToken && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

/** Format FastAPI error detail into a plain string. */
export function apiErrorMessage(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" · ");
  return String(d);
}

/** Guest token helpers - one JWT per apartment stored in localStorage map. */
export const guestTokens = {
  read() {
    try {
      return JSON.parse(localStorage.getItem("lp_guest_tokens") || "{}");
    } catch {
      return {};
    }
  },
  write(map) {
    localStorage.setItem("lp_guest_tokens", JSON.stringify(map));
  },
  set(apartmentId, token) {
    const m = guestTokens.read();
    m[apartmentId] = token;
    guestTokens.write(m);
  },
  clear(apartmentId) {
    const m = guestTokens.read();
    delete m[apartmentId];
    guestTokens.write(m);
  },
  isUnlocked(apartmentId) {
    return Boolean(guestTokens.read()[apartmentId]);
  },
};

/** Fetch reserved apartment content using the stored guest token. */
export async function fetchApartmentContent(apartmentId) {
  const token = guestTokens.read()[apartmentId];
  if (!token) throw new Error("No guest token");
  const { data } = await api.get(`/guest/apartment/${apartmentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
